import { render, staticRenderFns } from "./WorkflowCard.vue?vue&type=template&id=71c76d13"
import script from "./WorkflowCard.vue?vue&type=script&lang=js"
export * from "./WorkflowCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports